import { Layout } from 'components/layout'
import { useDataContext } from 'context/data-context'
import { Link } from 'react-router-dom'

export const Home = () => {
  const { articles } = useDataContext()

  return (
    <Layout noFooter>
      <p style={{ position: 'absolute', top: 0 }}>
        <Link to="/year/test">Go to article detail</Link>
      </p>
    </Layout>
  )
}
